/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';

export enum ActionTypes {
    GetLabels             = '[Content] - Get Labels',
    GetLabelsComplete     = '[Content] - Get Labels complete',
}

export class GetLabels implements Action {
    readonly type = ActionTypes.GetLabels;
    constructor(public payload?: {reload?: boolean}) {}
}

export class GetLabelsComplete implements Action {
    readonly type = ActionTypes.GetLabelsComplete;
    constructor(public payload: NonNullable<unknown>) {}
}

